import { Center } from '@ocodelib/mui';
import clsx from 'clsx';

interface Props {
  onClick: () => void;
  title: string;
  active: boolean;
  className?: string;
}

export function ContentTab(props: Props) {
  const { title, className, active, onClick } = props;

  const handleClick = () => {
    onClick();
  };

  return (
    <Center
      component="span"
      className={clsx('ContentTab-root', className, {
        'Mui-active': active,
      })}
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        position: 'relative',
        whiteSpace: 'nowrap',
        p: 1,
        minWidth: '4rem',
        background: 'transparent',
        color: 'primary.contrastText',
        fontSize: '0.85rem',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        height: 30,
        '&.Mui-active': {
          height: 32,
          fontSize: '0.85rem',
          cursor: 'default',
          color: '#000',
          bgcolor: '#edeff1',
          borderTop: '1px solid #dcdcdc',
          borderLeft: '1px solid #dcdcdc',
          borderRight: '1px solid #dcdcdc',
          // borderBottom: '1px solid #18269d',
        },
        '& .ContentTab-tabTextSpan': {
          maxWidth: '8rem',
          textAlign: 'center',
          flexGrow: 1,
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          display: 'inline-block',
        },
      }}
    >
      <span className="ContentTab-tabTextSpan">{title}</span>
    </Center>
  );
}
